import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { useContent } from "../../i18n/content";
import { SectionHeader } from "../SectionHeader";
import { Reveal } from "../motion/Reveal";

export const Platforms = () => {
    const { ui, companies } = useContent();
    return (
    <section id="platforms" data-testid="platforms-section" className="relative py-24 lg:py-32 bg-[#24251f]">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
            <SectionHeader
                chapter={ui.platforms.chapter}
                overline={ui.platforms.overline}
                title={ui.platforms.title}
                description={ui.platforms.description}
            />

            <Tabs defaultValue="digon" className="w-full">
                <TabsList className="w-full flex flex-wrap justify-start gap-0 bg-transparent h-auto p-0 border-b border-[#4a4c42] rounded-none mb-12">
                    {companies.map((c, i) => (
                        <TabsTrigger
                            key={c.slug}
                            value={c.slug}
                            data-testid={`platform-tab-${c.slug}`}
                            className="rounded-none bg-transparent shadow-none px-5 sm:px-8 py-4 font-display text-[11px] sm:text-xs font-bold tracking-[0.16em] uppercase text-[#a2a59d] border-b-2 border-transparent data-[state=active]:border-[#f6c422] data-[state=active]:text-[#f6c422] data-[state=active]:bg-transparent data-[state=active]:shadow-none hover:text-white transition-colors duration-300"
                        >
                            {ui.platforms.tabs[i]}
                        </TabsTrigger>
                    ))}
                </TabsList>

                {companies.map((c) => (
                    <TabsContent key={c.slug} value={c.slug} className="mt-0 focus-visible:outline-none">
                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                            <div className="lg:col-span-4">
                                <p className="overline-text">{c.category}</p>
                                <h3 className="font-display text-2xl sm:text-3xl font-extrabold uppercase text-white mt-3 leading-tight">
                                    {c.fullName}
                                </h3>
                                <p className="text-[#a2a59d] text-sm leading-relaxed mt-4 max-w-sm">
                                    {c.description}
                                </p>
                            </div>
                            <div className="lg:col-span-8">
                                {c.platforms.map((p, i) => (
                                    <Reveal key={p.num} delay={0.07 * i}>
                                        <div
                                            data-testid={`platform-item-${c.slug}-${p.num}`}
                                            className="group flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-10 py-6 border-t border-[#4a4c42] last:border-b hover:bg-[#32332c]/50 transition-colors duration-500 px-2 sm:px-4"
                                        >
                                            <span className="font-display text-3xl sm:text-4xl font-extrabold text-stroke-yellow shrink-0 w-16">
                                                {p.num}
                                            </span>
                                            <div>
                                                <h4 className="font-display text-lg sm:text-2xl font-bold uppercase tracking-wide text-white group-hover:text-[#f6c422] transition-colors duration-300">
                                                    {p.name}
                                                </h4>
                                                {p.desc && (
                                                    <p className="text-sm text-[#a2a59d] mt-2 max-w-xl leading-relaxed">{p.desc}</p>
                                                )}
                                            </div>
                                        </div>
                                    </Reveal>
                                ))}
                            </div>
                        </div>
                    </TabsContent>
                ))}
            </Tabs>
        </div>
    </section>
    );
};
